// ✅ EditItemModal.js
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Snackbar,
  Alert,
} from "@mui/material";
import { useOrder } from "../../../../../../../context/OrderCreator/TablesContext/OrderContext"; // 👈 استدعاء الـ context

const EditItemModal = ({ open, onClose, item }) => {
  const { updateItem } = useOrder(); // 👈 نجيب الدالة من الكونتكست
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (item) setForm({ ...item });
  }, [item]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = async () => {
    console.log("🚀 handleSubmit اشتغل، item:", item, "form:", form); // ✅

    try {
      setLoading(true);

      console.log("📤 ارسال للتعديل:", {
        id: item?.id,
        quantity: form.quantity,
        price: form.price,
        note: form.note,
      });

      await updateItem({
        id: Number(item?.id),
        quantity: form.quantity,
        price: form.price,
        note: form.note,
      });

      setSuccess(true);
      onClose && onClose(true);
    } catch (err) {
      console.error("❌ خطأ في handleSubmit:", err);
      setError(err.message || "❌ فشل في تعديل بيانات الصنف");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={() => onClose(false)} fullWidth>
        <DialogTitle>تعديل بيانات الصنف: {item?.product_name}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={6}>
              <TextField
                label="الكمية"
                name="quantity"
                type="number"
                fullWidth
                value={form.quantity || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="السعر"
                name="price"
                type="number"
                fullWidth
                value={form.price || ""}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="ملاحظات"
                name="note"
                fullWidth
                value={form.note || ""}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose(false)}>إلغاء</Button>
          <Button variant="contained" onClick={handleSubmit} disabled={loading}>
            حفظ التعديلات
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!error}
        autoHideDuration={3000}
        onClose={() => setError("")}
      >
        <Alert severity="error">{error}</Alert>
      </Snackbar>

      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
      >
        <Alert severity="success">تم تعديل بيانات الصنف بنجاح</Alert>
      </Snackbar>
    </>
  );
};

export default EditItemModal;
